module.exports = __webpack_public_path__ + "img/pwa-notifications-desktop-standalone-2.c9bb308b.png";